var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-application',[_c('v-layout',[_c('v-flex',{attrs:{"md8":""}},[_c('v-card',{staticClass:"mb-3"},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }